import {
  Box,
  Button,
  Card,
  CardContent,
  CircularProgress,
  Grid,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import InfluencerTypeList from "app/components/InfluencerTypeList";
import { useGetAllInfluencersQuery } from "lib/features/influencer/influencerService";
import { User } from "lib/features/user/types";
import { selectUser, setUser } from "lib/features/user/userSlice";
import { useAppDispatch, useAppSelector } from "lib/hooks";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import authServices from "services/auth-service";
import { businessCardStyles } from "styles/Home/businessCard.styles";
import { refereeScreenStyles } from "styles/RefereeDirectory/refereeScreen.styles";
import { parseImageUrl } from "util/parseImageUrl";
import GreenDot from "../../assets/icons/green_dot.svg";
import RefereeIcon from "../../assets/icons/referee_logo.svg";

interface RefereeCardProps {
  referee: User;
  user: User;
}
const RefereeCard = ({ referee, user }: RefereeCardProps) => {
  const navigate = useNavigate();
    const dispatch = useAppDispatch();
    const userData = localStorage.getItem("user") as string;
    const parsedUserObject = JSON.parse(userData) as User | undefined;
    const userId = parsedUserObject?.id;
    const role_id = parsedUserObject?.role_id;
    const [loading, setLoading] = useState<boolean>(false);


    const assumeUser = async (event: React.MouseEvent) => {
      event.stopPropagation();

      console.log("Assume user called");

      if (referee.id) {
        setLoading(true);
        authServices.assume(referee?.id).then((result) => {
          const token = result?.data?.token;
          const user: User = result?.data?.user;
          localStorage.setItem("token", token);
          localStorage.setItem("user", JSON.stringify(user) as string);
          dispatch(setUser(user));
          window.location.reload();
        }).catch((error) => {
          setLoading(false);

          console.log("error occured: ", error);
        });

      }
    };
    const deleteUser = async (event: React.MouseEvent) => {
        event.stopPropagation();
    
        console.log("Delete user called");
        if (!window.confirm("Are you sure you want to delete this user?")) {
          return;
        }
        console.log(referee);
        if (referee?.id) {
          setLoading(true);
          await authServices.delete(referee.id).then((response) => {
            console.log("User deleted successfully");
            console.log(response);  
            setLoading(false);
            window.location.reload();
          }).catch((error) => {
            setLoading(false);
    
            console.log("error occured: ", error);
          });
    
        }
      }

  return (
    <Card
      sx={refereeScreenStyles.refereeCard}
      onClick={() => navigate(`/profile/${referee?.id}`)}
    >
      <img
        alt="referee"
        src={parseImageUrl(referee?.avatar)}
        style={refereeScreenStyles.refereeCardImage}
      />
      <CardContent sx={refereeScreenStyles.refereeCardContent}>
        <Typography sx={refereeScreenStyles.refereeName}>
          {referee?.first_name} {referee?.last_name}
        </Typography>
        <Box sx={refereeScreenStyles.influencerTypeContainer}>
          <img src={GreenDot} alt="dot" width={10} height={10} />
          {referee?.influencer_type?.type && (
            <Typography sx={refereeScreenStyles.influencerTypeText}>
              {referee?.influencer_type?.type}
            </Typography>
          )}
        </Box>

        {referee?.work_place && (
          <Typography sx={refereeScreenStyles.workPlace}>
            {referee?.work_place}
          </Typography>
        )}

        {referee?.regions?.[0]?.region?.region && (
          <Typography sx={refereeScreenStyles.regionText}>
            {referee?.regions?.[0]?.region?.region}
          </Typography>
        )}
        

      </CardContent>
      {role_id === 5 ?  (
            <Box sx={{ mt: "auto" }}>
              <Button
                sx={businessCardStyles.filledButton}
                disabled={loading}
                onClick={assumeUser}
              >
                {loading ? (
                  <CircularProgress size={24} />
                ) : (
                  <>
                    <Typography sx={businessCardStyles.filledButtonTypography}>
                      Assume
                    </Typography>
                  </>
                )}
              </Button>
            </Box>
          ): null}
                    {role_id === 5 ?  (
            <Box sx={{ mt: "auto" }}>
              <Button
                sx={businessCardStyles.deleteButton}
                disabled={loading}
                onClick={deleteUser}
              >
                {loading ? (
                  <CircularProgress size={24} />
                ) : (
                  <>
                    <Typography sx={businessCardStyles.filledButtonTypography}>
                      Delete User
                    </Typography>
                  </>
                )}
              </Button>
            </Box>
          ): null}
    </Card>
  );
};

const Referees = () => {
  const theme = useTheme();
  const isXsScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const [userData, setUserData] = useState<User>();
  const user = useAppSelector(selectUser);
  const [filteredReferees, setFilteredReferees] = useState<User[]>([]);
  const [activeInfluencerType, setActiveInfluencerType] = React.useState<
    number | null
  >(null);

  const regionId = userData?.regions?.[0]?.region?.id;

  const { data: refereesData, isLoading } = useGetAllInfluencersQuery(
    regionId as number,
    { skip: !regionId }
  );

  const handleInviteClick = async () => {
    const link = "https://myreferee.app";
    const message = `Check out Referee! It's a great app for networking and referrals.`;

    if (navigator.share) {
      try {
        await navigator.share({
          title: "Referee App",
          text: message,
          url: link,
        });
      } catch (error) {
        console.error("Error sharing", error);
      }
    } else {
      try {
        await navigator.clipboard.writeText(link);
        alert("Link copied to clipboard!");
      } catch (error) {
        console.error("Failed to copy the link", error);
      }
    }
  };

  useEffect(() => {
    const fetchUserDetails = async () => {
      if (user?.id) {
        try {
          const response = await authServices.fetchUser(user.id);
          setUserData(response?.data);
        } catch (error: any) {
          console.error("Error fetching chats:", error?.message);
        } finally {
        }
      }
    };

    fetchUserDetails();
  }, []);

  useEffect(() => {

    if (refereesData) {
      console.log(refereesData)
      if (activeInfluencerType === null) {
        setFilteredReferees(refereesData);
      } else {
        const newRefereeArray = refereesData?.filter(
          (referee) => referee?.influencer_type?.id === activeInfluencerType
        );
        setFilteredReferees(newRefereeArray);
      }
    }
  }, [refereesData, activeInfluencerType]);

  return (
    <Box sx={refereeScreenStyles.outerContainer}>
      <InfluencerTypeList
        selectedInfluencer={activeInfluencerType}
        handleActiveCategory={(val: number | null) => {
          setActiveInfluencerType(val);
        }}
      />

      <Box sx={refereeScreenStyles.contentContainer}>
        <Typography variant="h1" sx={refereeScreenStyles.headerTypography}>
          Referees
        </Typography>

        {isLoading || !regionId ? (
          <Box sx={refereeScreenStyles.loadingContainer}>
            <CircularProgress />
          </Box>
        ) : (
          <>
            <Grid container spacing={isXsScreen ? 0 : 2} width={"100%"}>
              {filteredReferees && filteredReferees?.length > 0 ? (
                filteredReferees.map((referee: User, i: number) => (
                  <>
                  { referee.record_status !== false ? (
                    <Grid item xs={12} sm={6} md={4} lg={4} key={i}>
                      <RefereeCard referee={referee} user={user} />
                    </Grid>
                  ) : null}
                    
                  </>
                  
                ))
              ) : (
                <Typography sx={{ textAlign: "center", marginLeft: "15px" }}>
                  No Record found
                </Typography>
              )}
            </Grid>
            <Box>
              {filteredReferees && filteredReferees?.length > 0 && (
                <Box sx={refereeScreenStyles.inviteContainer}>
                  <Typography sx={refereeScreenStyles.inviteText}>
                    Don’t see an Individual you’d like to work with?{" "}
                    <span
                      style={refereeScreenStyles.inviteLink}
                      onClick={handleInviteClick}
                    >
                      Invite them to Referee!
                    </span>
                  </Typography>

                  <img src={RefereeIcon} />
                </Box>
              )}
            </Box>
          </>
        )}
      </Box>
    </Box>
  );
};

export default Referees;